import { Validators } from '@angular/forms';
import { PurchaseOrderComponent } from '@ordersnproducts/modules/one-click-order/components/purchase-order/purchase-order.component';
import { OneClickJobsiteSalesAreaFromOrderEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-jobsite-sales-area.effects-order';
import { OneClickDeliveryDateProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-date.provider';
import { OneClickRequestedTimeProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-requested-time.provider';
import { OneClickStandardLotProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-standard-lot.provider';
import { OneClickSetTimepickerDateFromDatepickerCommand } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-set-time-from-date-picker.comand.service';
import { OneClickSetPurchaseOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-purchase-order.command';
import { OneClickSetRequestedDateTime } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-requested-date-time.command.service';
import { defaultDateTranslationNames } from '@ordersnproducts/modules/order-builder/modules/specification/configs/defaultDateTranslationNames';
import { MINUTE_STEP_PL } from '@ordersnproducts/modules/order-builder/modules/specification/configs/pl/constants';
import { TimepickerHourFormat } from '@ordersnproducts/modules/shared/components/cmx-timepicker/cmx-timepicker.component';
import { FormInputDateComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/form-input-date.component';
import { FieldDateInputConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/field-date-input.config';
import { WeekDay } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/week-day';
import { FormInputTimeComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-time/form-input-time.component';
import { FieldInputTimeConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-time-config.interface';
import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { OneClickLocationProvider } from '../../../../providers/order/one-click-location.provider';
import { OneClickLocationDisplayer } from '../../../../providers/order/one-click-multiple-jobsite-displayer.provider';
import {
  OneClickHasResultProvider,
  OneClickNoResultProvider,
  OneClickPaymentProvider,
} from '../../../../providers/order/one-click-payment.provider';
import { OneClickProductProvider } from '../../../../providers/order/one-click-product.provider';
import { OneClickPurchaseOrderProvider } from '../../../../providers/order/one-click-purchase-order.provider';
import { OneClickPreviewField } from '../../../../util/constants/preview-fields';
import { OneClickFeatureConfig } from '@ordersnproducts/modules/one-click-order/models/one-click-feature-config';
import { OneClickElementConfig } from '@ordersnproducts/modules/one-click-order/models/one-click-element-config';
import { OneClickElement } from '@ordersnproducts/modules/one-click-order/util/enums/one-click-element';

export const preview: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Jobsite,
    label: 'views.one_click.jobsite',
    hidden: OneClickLocationDisplayer.HideJobsite,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagjobsite',
    dataTIdValue: 'cmx-createoneclickorder-lblvaljobsite',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Product,
    text: OneClickProductProvider,
    label: 'views.one_click.product',
    dataTIdLabel: 'cmx-createoneclickorder-lbltagproduct',
    dataTIdValue: 'cmx-createoneclickorder-lblvalproduct',
    containerClassNames: ['col-md-4 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Quantity,
    text: OneClickStandardLotProvider,
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-4 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagquantity',
    dataTIdValue: 'cmx-createoneclickorder-lblvalquantity',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Payment,
    text: OneClickPaymentProvider,
    label: 'views.one_click.payment_method',
    containerClassNames: ['col-md-4 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpayment',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpayment',
  } as FieldLabelConfig,
  {
    type: FormInputDateComponent,
    name: OneClickPreviewField.DeliveryDate,
    label: 'views.one_click.delivery_date',
    placeholder: 'mm/dd/yyyy',
    translationNames: defaultDateTranslationNames,
    startWeekWith: WeekDay.MONDAY,
    onChange: [OneClickSetRequestedDateTime, OneClickSetTimepickerDateFromDatepickerCommand],
    hidden: OneClickHasResultProvider,
    containerClassNames: ['col-md-4 text-capitalize retail-control'],
    validation: [Validators.required],
    relativePosition: true,
    hideOutsideDays: true,
  } as FieldDateInputConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.DeliveryDate,
    hidden: OneClickNoResultProvider,
    text: OneClickDeliveryDateProvider,
    label: 'views.one_click.delivery_date',
    containerClassNames: ['col-md-4 text-capitalize retail-control'],
  } as FieldLabelConfig,
  {
    type: FormInputTimeComponent,
    label: 'views.one_click.request_time',
    name: OneClickPreviewField.Time,
    containerClassNames: ['col-md-4 text-capitalize retail-control'],
    hourFormat: TimepickerHourFormat.format24,
    minuteStep: MINUTE_STEP_PL,
    onChange: [OneClickSetRequestedDateTime],
    validation: [Validators.required],
    dataTIdLabel: 'cmx-createoneclickorder-seltagtimewindow',
    dataTIdValue: 'cmx-createoneclickorder-selvaltimewindow',
    hidden: OneClickHasResultProvider,
  } as FieldInputTimeConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Time,
    hidden: OneClickNoResultProvider,
    text: OneClickRequestedTimeProvider,
    label: 'views.one_click.request_time',
    containerClassNames: ['col-md-4 text-capitalize retail-control'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagtimewindow',
    dataTIdValue: 'cmx-createoneclickorder-lblvaltimewindow',
  } as FieldLabelConfig,
  {
    type: PurchaseOrderComponent,
    name: OneClickPreviewField.PurchaseOrder,
    label: 'views.one_click.purchase_order',
    dynamicEffects: [OneClickJobsiteSalesAreaFromOrderEffects],
    onChange: [OneClickSetPurchaseOrder],
    hidden: OneClickHasResultProvider,
    placeholder: 'views.one_click.enter_purchase_order',
    containerClassNames: ['col-md-4 text-capitalize retail-control'],
  } as FieldConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PurchaseOrder,
    hidden: OneClickNoResultProvider,
    text: OneClickPurchaseOrderProvider,
    label: 'views.one_click.purchase_order',
    containerClassNames: ['col-md-4'],
  } as FieldLabelConfig,
];

export const features: OneClickFeatureConfig = {
  [OneClickElement.TERMS_AND_CONDITIONS]: {
    name: OneClickElement.TERMS_AND_CONDITIONS,
  } as OneClickElementConfig,
};
